
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/eliminate-fake-appointments",
      function () {
        return require("private-next-pages/eliminate-fake-appointments.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/eliminate-fake-appointments"])
      });
    }
  